module.exports = __webpack_public_path__ + "img/facebook.ca04d942.svg";